import "../styles/Recipe.css";
import "../styles/Buttons.css";

import React from "react";

function TNavbar(props) {
  const {
    title,
    rbuttonIcon,
    lbuttonIcon,
    rbackground,
    lbackground,
    rfunction,
    lfunction,
  } = props;
  

  return (
    <div className="spc-between topnav-container">
       <a className={rbackground} onClick={rfunction}>
        {rbuttonIcon.map((icon, index) => (
          <div key={index}>
            <span className={icon}></span>
          </div>
        ))}
      </a>

      <p className="heading-1">{title}</p>

      <a className={lbackground} onClick={lfunction}>
        {lbuttonIcon.map((icon, index) => (
          <div key={index}>
            <span className={icon}></span>
          </div>
        ))}
      </a>
    </div>
  );
}

export default TNavbar;